import React, { Component } from 'react'
import moment from 'moment'
import firebase from 'firebase/app'
import update from 'immutability-helper'
import PropTypes from 'prop-types'
import GridList from '@material-ui/core/GridList'
import Grid from '@material-ui/core/Grid'
import Chip from '@material-ui/core/Chip'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Avatar from '@material-ui/core/Avatar'
import TextField from '@material-ui/core/TextField'
import ListSubHeader from '@material-ui/core/ListSubheader'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import { getFullName, formatDate } from '../helpers'
import { USER_TYPE, ROUTES, GENDER } from '../constant'
import {
  loading,
  unload,
  setSnackSuccess,
} from '../actions/app'
import {
  getUser,
  editUser,
  editFolio,
  removeFolio,
  declinePermission,
  validatePermission,
  browseWaitingProfiles,
} from '../actions/admin'

import Folio from '../components/Folio'
import Button from '../components/Button'
import Upload from '../components/Upload'
import Loading from '../components/Loading'
import Section from '../components/Section'
import TagField from '../components/TagField'
import Breadcrumb from '../components/Breadcrumbs'
import BookSelection from '../components/BookSelection'
import PaginationItem from '../components/PaginationItem'
import CharacteristicsPdf from '../assets/characteristics.pdf'


const styles = theme => ({
  section: {
    marginRight: 20,
  },
  sectionInfo: {
    width: 350,
  },
  smokeColor: {
    color: 'silver',
  },
  header: {
    position: 'relative',
    alignItems: 'flex-start',

    [theme.breakpoints.down('lg')]: {
      alignItems: 'center',
    },
  },
  alertTypo: {
    width: '100%',
    display: 'block',
    textAlign: 'center',
  },
  type: {
    left: 0,
    position: 'absolute',
    top: 'calc(100% - 30px)',

    '& > *': {
      width: 50,
      height: 50,
    },
  },
  avatar: {
    width: 200,
    height: 200,
    margin: '0 auto',
  },
  separator: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  inline: {
    display: 'flex',
    alignItems: 'center',

    '& > *:first-child': {
      marginRight: 5,
    },

    '& > *:last-child': {
      marginLeft: 5,
    },
  },
  justifyCenter: {
    justifyContent: 'space-between',
  },
  modalContainer: {
    top: '50%',
    left: '50%',
    width: '90%',
    maxWidth: 1166,
    height: '60vh',
    outline: 'none',
    position: 'absolute',
    backgroundSize: 'cover',
    transform: 'translateX(-50%) translateY(-50%)',
    backgroundPosition: 'center',
  },
})


class User extends Component {
  /* LIFECYCLE */
  state = {
    tag: '',
    book: [],
    edit: null,
    folio: null,
  }

  /**
   * @componentWillMount
   */
  componentWillMount() {
    if (this.props.isConnected) {
      this.props.getUser(this.props.match.params.id)
    }
  }


  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const {
      user,
      match,
      location,
      isConnected,
      waitingProfiles,
    } = nextProps

    if ((location.pathname !== this.props.location.pathname && isConnected) || (isConnected && !this.props.isConnected)) {
      this.props.getUser(match.params.id)
    }

    if (user !== this.props.user && user && user.permission && user.permission.pending && !waitingProfiles.length) {
      this.props.browseWaitingProfiles()
    }
  }


  /* METHODS */

  getBreadcrumbUserByUser = (user) => {
    if (!user || (user && user.permission && user.permission.pending)) {
      return { label: 'Waiting approvals', to: `${ROUTES.HOME}` }
    }

    if (user.type === USER_TYPE.MODEL) {
      return { label: 'Model', to: ROUTES.MODELS }
    }

    return { label: 'Photographer', to: ROUTES.PHOTOGRAPHERS }
  }

  /**
   * When input has changed
   */
  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  /**
   * Create a tag for the current user
   */
  createUserTag = () => {
    const { tag } = this.state
    const {
      objectID,
      tags = [],
    } = this.props.user

    if (!tags.includes(tag)) {
      this.props.editUser(objectID, {
        tags: tags.concat(tag),
      })
    }

    this.setState({ tag: '' })
  }

  /**
   * When visible checkbox has been changed
   */
  createOnVisibleChangeHandler = folio => () => {
    const {
      objectID,
      is_hidden,
    } = folio

    this.props.editFolio(this.props.user.objectID, objectID, {
      is_hidden: !is_hidden,
    })
  }

  /**
   * When a tag has been added
   */
  createAddTagHandler = folio => (tag) => {
    const {
      objectID,
      tags = [],
    } = folio

    this.props.editFolio(this.props.user.objectID, objectID, {
      tags: tags.concat(tag),
    })
  }

  /**
   * When a tag has been removed
   */
  createDeleteTagHandler = folio => (tag) => {
    const {
      objectID,
      tags = [],
    } = folio

    this.props.editFolio(this.props.user.objectID, objectID, {
      tags: tags.filter(t => t !== tag),
    })
  }

  /**
   * When a user tag has been removed
   */
  createDeleteUserTagHandler = tag => () => {
    const {
      objectID,
      tags = [],
    } = this.props.user

    this.props.editUser(objectID, {
      tags: tags.filter(t => t !== tag),
    })
  }

  createRemoveFolioHandler = folio => () => this.props.removeFolio(folio)

  createOpenLink = url => () => window.open(url, '_blank')

  createPermissionHandler = fn => () => fn(this.props.user.objectID, true)

  handleChangeUser = (userId) => {
    this.props.history.push(`${ROUTES.USER}/${userId}`)
  }

  handleEditCharacteristicsChange = e => this.setState({
    edit: update(this.state.edit, {
      characteristics: {
        [e.target.name]: {
          $set: e.target.value,
        },
      },
    }),
  })

  handleEditAddressChange = e => this.setState({
    edit: update(this.state.edit, {
      address: {
        [e.target.name]: {
          $set: e.target.value,
        },
      },
    }),
  })

  handleEditChange = e => this.setState({
    edit: update(this.state.edit, {
      [e.target.name]: {
        $set: e.target.value,
      },
    }),
  })

  handleToggleEdition = async () => {
    const { user: algoliaUser } = this.props
    const { edit } = this.state
    const isEdition = !!edit
    const userId = algoliaUser.objectID || algoliaUser.id
    const db = firebase.firestore()

    this.props.loading()

    if (!isEdition) {
      const snap = await db.collection('users').doc(userId).get()
      const user = snap.data()
      
      return this.setState({
        edit: {
          address: user.address ? Object.assign({}, user.address) : {},
          characteristics: user.type !== USER_TYPE.PHOTOGRAPHER ? Object.assign({}, user.characteristics || {}) : null,
          email: user.email || '',
          lastname: user.lastname || '',
          firstname: user.firstname || '',
          instagram: user.instagram || '',
          description: user.description || '',
        },
      }, this.props.unload)
    }

    await db.collection('users').doc(userId).update(this.state.edit)

    this.setState({ edit: null }, () => {
      this.props.unload()
      this.props.setSnackSuccess('Informations has been successfully saved. It will be effectively in 30seconds.')
    })
  }

  handleCreateBook = () => {
    const { book } = this.state
    const { user: algoliaUser } = this.props
    const userId = algoliaUser.objectID || algoliaUser.id

    window.open(`${window.location.origin}/admin/book/${userId}?folio=${book.join(',')}`)
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      user,
      classes,
      isLoading,
      waitingProfiles,
    } = this.props
    const {
      tag,
      edit,
      book,
      folio,
    } = this.state

    const tags = user && user.tags
    const permission = user && user.permission
    const portfolio = user && user.folios || []
    const picture = user && (user.thumbnail || user.picture)
    const isInWaitingList = user && user.permission && user.permission.pending
    const characteristics = user && user.type === USER_TYPE.MODEL ? user.characteristics || {} : null

    const isEdition = !!edit

    return (
      <div>
        <Breadcrumb
          data={[
            { label: 'Home', to: ROUTES.HOME },
            this.getBreadcrumbUserByUser(user),
            user ? getFullName(user) : 'User',
          ]}
        />

        {user && isEdition && (
          <AppBar
            color="secondary"
            position="static"
            className="mt3"
          >
            <Toolbar>
              <Typography
                component="a"
                target="_blank"
                color="inherit"
                href={CharacteristicsPdf}
                className={classes.alertTypo}
              >
                Caution, please check the list valid values for characteristics
              </Typography>
            </Toolbar>
          </AppBar>
        )}

        {isInWaitingList && (
          <PaginationItem
            items={waitingProfiles}
            label="Users remaining to validate"
            onItemChange={this.handleChangeUser}
            item={user && (user.objectID || user.id)}
          />
        )}

        <Grid container direction="row" wrap="nowrap" className={classes.root}>
          <Grid container direction="column" wra="nowrap">
            {!!user && (
              <Section title="Informations" className={classes.section}>
                {characteristics && (
                  <>
                    <ListSubHeader className="mt1" disableSticky>Characteristics</ListSubHeader>

                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Height</TableCell>
                          <TableCell>Bust</TableCell>
                          <TableCell>Waist</TableCell>
                          <TableCell>Hips</TableCell>
                          <TableCell>Shoes</TableCell>
                          <TableCell>Hair</TableCell>
                          <TableCell>Ethnicity</TableCell>
                          <TableCell>Eyes</TableCell>
                          <TableCell>Gigs</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>
                            {isEdition ? <TextField name="height" value={edit.characteristics.height || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.height || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="bust" value={edit.characteristics.bust || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.bust || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="waist" value={edit.characteristics.waist || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.waist || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="hips" value={edit.characteristics.hips || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.hips || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="shoes" value={edit.characteristics.shoes || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.shoes || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="hair" value={edit.characteristics.hair || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.hair || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="ethnicity" value={edit.characteristics.ethnicity || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.ethnicity || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="eyes" value={edit.characteristics.eyes || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.eyes || '/')}
                          </TableCell>
                          <TableCell>
                            {isEdition ? <TextField name="gigs" value={edit.characteristics.gigs || ''} onChange={this.handleEditCharacteristicsChange} /> : (characteristics.gigs || '/')}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </>
                )}

                {isEdition && edit.address && (
                  <>
                    <ListSubHeader className="mt6" disableSticky>Address</ListSubHeader>

                    <div className={classes.inline}>
                      <TextField fullWidth label="Latitude" name="latitude" onChange={this.handleEditAddressChange} value={edit.address.latitude || ''} />
                      <TextField fullWidth label="Longitude" name="longitude" onChange={this.handleEditAddressChange} value={edit.address.longitude || ''} />
                    </div>

                    <TextField fullWidth className="mt3" label="City" name="city" onChange={this.handleEditAddressChange} value={edit.address.city || ''} />
                    <TextField fullWidth className="mt3" label="Country" name="country" onChange={this.handleEditAddressChange} value={edit.address.country || ''} />
                  </>
                )}
              </Section>
            )}

            <Section title="Tags" className={classes.section}>
              {isLoading && <Loading text="Loading..." />}
              {!isLoading && user && (
                <>
                  <TagField
                    name="tag"
                    fullWidth
                    value={tag}
                    className="mt2"
                    placeholder="New tag"
                    isLoading={isLoading}
                    onChange={this.handleChange}
                    onClick={this.createUserTag}
                  />

                  {Array.isArray(tags) && (
                    <Grid container className="mt2">
                      {tags.map(currentTag => (
                        <Chip
                          className="mr1"
                          key={currentTag}
                          label={currentTag}
                          disabled={isLoading}
                          onDelete={this.createDeleteUserTagHandler(currentTag)}
                        />
                      ))}
                    </Grid>
                  )}
                </>
              )}
            </Section>

            <Section closedByDefault title="Book" className={classes.section}>
              <BookSelection name="book" folios={portfolio} value={book} onChange={this.handleChange} />
              <Button
                fullWidth
                className="mt3"
                color="primary"
                variant="contained"
                disabled={book.length < 1}
                onClick={this.handleCreateBook}
              >
                Create book with {book.length} picture{book.length > 1 ? 's' : ''}
              </Button>
            </Section>

            <Section title="Portfolio" className={classes.section}>
              {portfolio.length > 0 && (
                <GridList cellHeight={500} className={classes.justifyCenter}>
                  {portfolio.map(folio => (
                    <Folio
                      key={folio.objectID}
                      {...folio}
                      onAddTag={this.createAddTagHandler(folio)}
                      onRemove={this.createRemoveFolioHandler(folio)}
                      onDeleteTag={this.createDeleteTagHandler(folio)}
                      onVisibleChange={this.createOnVisibleChangeHandler(folio)}
                    />
                  ))}
                </GridList>
              )}

              <Upload
                name="folio"
                value={folio}
                type="user_profile"
                onChange={this.handleChange}
                uid={user && (user.objectID || user.id)}
                component={props => (
                  <Button
                    {...props}
                    fullWidth
                    color="primary"
                    className="mt3"
                    variant="contained"
                  >
                    Upload an image
                  </Button>
                )}
              />
            </Section>
          </Grid>

          <Grid container direction="column" alignItems="center" justify="flex-start" className={classes.sectionInfo}>
            <Section title="Infos" className={classes.sectionInfo}>
              {picture && <Avatar className={classes.avatar} src={picture} />}

              {user && !isEdition && (
                <>
                  <Grid container wrap="nowrap" className="mt2">
                    <Typography className={classes.smokeColor}>Type:</Typography>
                    <Typography className="ml1" color={user.type === USER_TYPE.MODEL ? 'primary' : 'secondary'}>{user.type === USER_TYPE.MODEL ? 'Model' : 'Photographer'}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Email:</Typography>
                    <Typography className="ml1">{user.email}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Name:</Typography>
                    <Typography className="ml1">{getFullName(user)}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Description:</Typography>
                    <Typography className="ml1">{user.description}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Register date:</Typography>
                    <Typography className="ml1">{formatDate(user.created_at)}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Instagram:</Typography>
                    <Typography className="ml1">{user.instagram}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Location:</Typography>
                    <Typography className="ml1">{user.address_city || 'N/A'}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Country:</Typography>
                    <Typography className="ml1">{user.address_country || 'N/A'}</Typography>
                  </Grid>
                </>
              )}

              {user && isEdition && (
                <>
                  <TextField fullWidth className="mt3" label="Email" name="email" type="email" onChange={this.handleEditChange} value={edit.email} />
                  <TextField fullWidth className="mt3" label="First Name" name="firstname" onChange={this.handleEditChange} value={edit.firstname} />
                  <TextField fullWidth className="mt3" label="Last Name" name="lastname" onChange={this.handleEditChange} value={edit.lastname} />
                  <TextField fullWidth multiline rows={3} className="mt3" label="Description" name="description" onChange={this.handleEditChange} value={edit.description} />
                  <TextField fullWidth className="mt3" label="Instagram" name="instagram" onChange={this.handleEditChange} value={edit.instagram} />
                </>
              )}

              {user && user.type === USER_TYPE.PHOTOGRAPHER && (
                <Button
                  fullWidth
                  className="mt6"
                  variant="contained"
                  disabled={!user.idcard_picture}
                  onClick={this.createOpenLink(user && user.idcard_picture)}
                >
                  Show ID Card
                </Button>
              )}


              <Button
                fullWidth
                className="mt6"
                variant="contained"
                onClick={this.handleToggleEdition}
                color={isEdition ? 'secondary' : 'primary'}
              >
                {isEdition ? 'Save' : 'Edit informations'}
              </Button>
            </Section>

            <Section title="Stats" className={classes.sectionInfo}>
              {user && (
                <>
                  <Grid container wrap="nowrap" className="mt3">
                    <Typography className={classes.smokeColor}>Appearances:</Typography>
                    <Typography className="ml1">{user.appearance || 0}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Views:</Typography>
                    <Typography className="ml1">{user.views || 0}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Likes receive/emitted:</Typography>
                    <Typography className="ml1">{user.liked || 0} / {user.likes || 0}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Matchs:</Typography>
                    <Typography className="ml1">{user.user_matches_count || 0}</Typography>
                  </Grid>
                </>
              )}
            </Section>

            <Section title="Permission" className={classes.sectionInfo}>
              {user && (
                <>
                  {permission && (permission.validated_at || permission.declined_at) && <Typography color={permission.validated_at ? 'primary' : 'secondary'}>This profil has been {permission.validated_at ? 'validated' : 'declined'} on {moment(permission.validated_at ? permission.validated_at : permission.declined_at).format('DD/MM/YYYY HH:mm')}</Typography>}
                  {(!permission || (permission && !permission.validated_at && !permission.declined_at)) && <Typography>This profil is awaiting for approval</Typography>}

                  <Grid container>
                    {(!permission || (permission && !permission.validated_at)) && (
                      <Button
                        fullWidth
                        color="primary"
                        className="mt3"
                        variant="contained"
                        isLoading={isLoading}
                        onClick={this.createPermissionHandler(this.props.validatePermission)}
                      >
                        Validate permission
                      </Button>
                    )}

                    {(!permission || (permission && !permission.declined_at)) && (
                      <Button
                        fullWidth
                        color="secondary"
                        className="mt3"
                        variant="contained"
                        isLoading={isLoading}
                        onClick={this.createPermissionHandler(this.props.declinePermission)}
                      >
                        Decline permission
                      </Button>
                    )}
                  </Grid>
                </>
              )}
            </Section>
          </Grid>
        </Grid>
      </div>
    )
  }
}


User.propTypes = {
  user: PropTypes.object,
  unload: PropTypes.func,
  loading: PropTypes.func,
  removeFolio: PropTypes.func,
  history: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  getUser: PropTypes.func.isRequired,
  editUser: PropTypes.func.isRequired,
  editFolio: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  isConnected: PropTypes.bool.isRequired,
  setSnackSuccess: PropTypes.func.isRequired,
  declinePermission: PropTypes.func.isRequired,
  validatePermission: PropTypes.func.isRequired,
  browseWaitingProfiles: PropTypes.func.isRequired,
  waitingProfiles: PropTypes.arrayOf(PropTypes.string),
}


const mapStateToProps = state => ({
  user: state.admin.user,
  isLoading: state.app.isLoading,
  isConnected: state.user.isConnected,
  waitingProfiles: state.admin.waitingProfiles,
})


export default connect(mapStateToProps, {
  unload,
  loading,
  getUser,
  editUser,
  editFolio,
  removeFolio,
  setSnackSuccess,
  declinePermission,
  validatePermission,
  browseWaitingProfiles,
})(withStyles(styles)(User))
